import events from './events'
import store from 'reducers'
import Actions from './Actions'
import { 
    SelectedTimeSlotActions,
    SelectedPatientActions,
    FilterActions,
    AvailabilityActions,
    CompletedPageActions,
    SelectedCardActions 
} from 'actions'

export default class PageActions extends Actions{
    static get target(){
        return 'page'
    }

    static navToTimeSlots(){
        this.set('timeSlots')
        CompletedPageActions.append('timeSlots')
    }

    static navToCollectInformation(){
        this.set('collectInformation')
        CompletedPageActions.append('collectInformation')
    }

    static navToConfirmation(){
        this.set('confirmation')
        CompletedPageActions.append('confirmation')
    }

    static navToPayment(){
        this.set('payment')
         CompletedPageActions.append('payment')
    }

    static navToReceipt(){
        this.set('receipt')
        CompletedPageActions.append('receipt')
    }

    static navToEmptyPage(){
        this.set('empty')
    }

    static reset(){
        this.set('sessions')
        SelectedTimeSlotActions.clear()
        SelectedPatientActions.clear()
        FilterActions.reset()
        CompletedPageActions.reset()
        AvailabilityActions.clear()
        SelectedCardActions.clear()
    }
}


// WEBPACK FOOTER //
// ./actions/PageActions.js